import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/versionHistory';

export const updateVersionHistory = createAction(types.UPDATE_VERSION_HISTORY);
export const clearVersionHistory = createAction(types.CLEAR_VERSION_HISTORY);
export const updateVersionHistoryItem = createAction(types.UPDATE_VERSION_HISTORY_ITEM);
export const updateVersionHistoryItemLoadedStatus = createAction(types.UPDATE_VERSION_HISTORY_ITEM_LOADED_STATUS);
export const updateVersionHistoryItemSavingStatus = createAction(types.UPDATE_VERSION_HISTORY_ITEM_SAVING_STATUS);
export const updateVersionHistoryLatestSavedItem = createAction(types.UPDATE_VERSION_HISTORY_LATEST_SAVED_ITEM);
